import { render, staticRenderFns } from "./list-form.vue?vue&type=template&id=c0ba636a&"
import script from "./list-form.vue?vue&type=script&lang=js&"
export * from "./list-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports